module.exports = ({React,connect,ToolbarActions,ElementLabel})->

  class ResourceTag extends React.Component

    constructor:(props)->
      super(props)
    
    render:->
      active = @props.isSelected && @props.textedit_active_node.type == "duoresource"
      <view3d-tag {...@props.attributes} {...@props.props}></view3d-tag>
      
  connect((state)->
    toolbars_active:state.toolbars_active
    textedit_active_node:state.textedit_active_node
  )(ResourceTag)